/** Sign-up = access request (ALP-85): the request form, its confirmation, and the sign-in messages while it is reviewed. */
export const access = {
  title: "Request access to Malfak",
  hint: "Tell us about you and your business. Our team reviews every request and contacts you, usually within one business day.",
  steps: { you: "You", contact: "Contact", business: "Your business" },
  fields: {
    email: "Work email",
    username: "Username",
    usernameHint: "3–30 characters: letters, numbers, dot, dash or underscore. It becomes your handle in Malfak.",
    password: "Password",
    passwordHint: "At least 10 characters. Mix letters, numbers and symbols.",
    phone: "Phone number",
    phoneHint: "We call or message you about your request.",
    country: "Country code",
    company: "Company or brand",
    optional: "optional",
    reason: "What would you like to use Malfak for?",
    reasonHint: "A few lines about your account and goals (at least 20 characters).",
    reasonPlaceholder: "For example: we sell online through Instagram and get many price questions in comments and DMs…",
    heardFrom: "How did you hear about us?",
    heardFromNone: "Choose one",
    consentBefore: "I agree to the",
    consentAnd: "and the",
    terms: "Terms",
    privacy: "Privacy Policy",
    honeypot: "Leave this field empty",
  },
  heard: { instagram: "Instagram", search: "Search engine", friend: "A friend or colleague", event: "An event", partner: "A partner or agency", other: "Other" },
  strength: { label: "Password strength: {{level}}", s0: "too short", s1: "weak", s2: "fair", s3: "good", s4: "strong" },
  username: { checking: "Checking…", available: "Available", taken: "This username is taken", reserved: "This username is reserved", invalid: "Use 3–30 letters, numbers, dot, dash or underscore" },
  errors: {
    required: "Required",
    invalid_email: "Enter a valid email address",
    too_short: "Too short",
    too_long: "Too long",
    invalid_chars: "Use letters, numbers, dot, dash or underscore (not at the start or end)",
    reserved: "This username is reserved",
    taken: "This username is taken",
    too_weak: "Choose a stronger password",
    invalid_phone: "Enter a valid number for the selected country",
    reason_short: "Tell us a bit more (at least 20 characters)",
    consent_required: "Please accept the Terms and Privacy Policy",
    captcha_failed: "The security check failed. Please try again.",
    rateLimited: "Too many requests from this network. Please try again later.",
    generic: "Something went wrong. Please try again.",
  },
  submit: "Send request",
  submitting: "Sending…",
  haveAccount: "Already approved?",
  goLogin: "Sign in",
  reasonCount_one: "{{count}} / 2000",
  reasonCount_other: "{{count}} / 2000",
  received: {
    title: "Thanks, we'll contact you",
    text: "Your request reached our team. We review every request personally and get back to you by phone or email, usually within one business day.",
    next: "What happens next",
    step1: "We read your request and may call you with a few questions.",
    step2: "Once approved, sign in with the email and password you chose.",
    step3: "Connect your Instagram account and start in minutes.",
    back: "Back to the home page",
    login: "Go to sign in",
  },
  login: {
    pendingTitle: "Your request is under review",
    pending: "We'll contact you soon. You can sign in as soon as your access is approved.",
    rejectedTitle: "Your request was not approved",
    rejected: "We couldn't approve this request. If you think this is a mistake, request access again with more details.",
    noAccount: "No account yet?",
    request: "Request access",
  },
};
